module.exports = __webpack_public_path__ + "static/woman-wheelchair-square.0f2bd760.jpg";